import axios from 'axios';
import { Fragment, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { CommonLoading } from 'react-loadingg';
import AddPayrollPic from './AddPayrollPic';
import ManagePayrollPicHeader from './ManagePayrollPicHeader';
import PayrollPicList from './PayrollPicList';


const ManagePayrollPic = (props) => {
    const [payrollPicGroups, setPayrollPicGroups] = useState([]);
    const [factories, setFactories] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [showEdit, setShowEdit] = useState(false);

    const [addGroupModal, setOpenAddGroupModal] = useState(false);    

    const handleAddGroupModal = () => setOpenAddGroupModal(!addGroupModal);

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    item.permissionName.includes('Admin Role') &&
                    item.permissionType.includes('view')
                // ||
                // (item.permissionName.includes("Bulletin Board") && item.permissionType.includes("view"))
            );

            if (!permit) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            } else {
                setIsLoading(false);
            }

            const editPermit = loginListFromParent.some(
                (item) =>
                    item.permissionName.includes('Admin Role') &&
                    item.permissionType.includes('edit')
                // ||
                // (item.permissionName.includes("Bulletin Board") && item.permissionType.includes("edit"))
            );

            if (editPermit) {
                setShowEdit(true);
            }
        }
    }, [props.loginList]);

    useEffect(() => {
        const getPayrollPicGroups = async () => {
            const payrollPicsFromServer = await fetchPayrollPicGroups();
            setPayrollPicGroups(payrollPicsFromServer);
        };

        getPayrollPicGroups();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Fetch payroll pic
    const fetchPayrollPicGroups = async () => {
        const url = REACT_APP_API_BACKEND_URL + '/api/resignation/getpayrollpics';
        const res = await axios.post(url, { resign_payroll_id: "" , factory_id: ""});
        console.log(res);
        const data = await res.data.ResignList;
        console.log(data);
        // filter the resign list for only when status is 1
        const filteredData = data.filter((item) => item.status === "1");
        console.log(filteredData);
    

        return filteredData;
    };

   

    // Add Payroll PIC
    // ! Need to change this api to add group instead of group
    const addPayrollPic = (pic) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/resignation/addpayrollpics';
        const payrollPicDetails = {
            factory_id: pic.factoryId,
            payrollBadgeId: pic.payrollPicBadgeId,
            payrollName: pic.payrollPicName,
            payrollUsername: pic.payrollPicUsername,
            payrollEmail: pic.payrollPicEmail,
            created_by: pic.createdBy,
        };

        console.log(payrollPicDetails);
        console.log(url);

        // const res = 
        axios
            .post(url, payrollPicDetails)

            // console.log(res);
            .then(
                (response) => {
                    //!==== check the response then alert differently
                    console.log(response);
                    if(response.data.statusCode == "200" && response.data.desc == "Successfully added new Payroll Resign."){
                        alert('Factory Payroll PIC has been successfully created!');
                    } else if(response.data.statusCode == "201" && response.data.desc == "User already has the factory for this app."){
                        alert('Factory Payroll PIC already exists! Please add another new payroll PIC!');
                    }
                },
                setTimeout(() => {
                    setOpenAddGroupModal(!addGroupModal);
                }, 500),
                setTimeout(() => {
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err)
            );
    };

    const PayrollPicLists = () => {
        return (
            <Fragment>
                {payrollPicGroups.length > 0 ? (
                    <PayrollPicList
                        payrollDetails={payrollPicGroups}
                        showEdit={showEdit}
                        token={props.cognitoToken.idToken.jwtToken}
                    />
                ) : (
                    <div>No permission group has been created</div>
                )}
            </Fragment>
        );
    };

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${
                            props.isActive ? 'container is-active' : 'container'
                        }`}
                    >
                        <ManagePayrollPicHeader />
                        <div className='table-wrapper'>
                            <Button onClick={handleAddGroupModal}>
                                Create New
                            </Button>
                            <AddPayrollPic
                                show={addGroupModal}
                                handleClose={handleAddGroupModal}
                                onAdd={addPayrollPic}
                                factories={factories}
                                token={props.cognitoToken.idToken.jwtToken}
                                // getUserDetails = {getUserDetails}
                            />
                            <PayrollPicLists />
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default ManagePayrollPic;
